export default __webpack_public_path__ + "img/tiny-2.72f30c23.jpg";